// عناوين الأقسام ونصوصها العامة — تُستخدم مع SectionHeader
export const headers = {
  features: {
    overline: "المزايا",
    title: "مميزات مبتكرة لأعمال أكثر نجاحًا",
    subtitle: "كل ما تحتاجه لإدارة عملياتك بكفاءة وسهولة.",
  },
  software: {
    overline: "البرنامج",
    title: "كل الأدوات التي تحتاجها — في واجهة عربية بسيطة",
    subtitle:
      "من نقطة البيع إلى لوحة التحكم والتقارير، تجربة سلسة ومتوافقة مع متطلبات المملكة.",
  },
  devices: {
    overline: "الأجهزة",
    title: "حلول أجهزة متوافقة مع البرنامج والفوترة الإلكترونية",
    subtitle: "جاهزة للعمل ومتكاملة مع نظام المحاسب المحترف.",
  },
  pricing: {
    overline: "الخطط والأسعار",
    title: "استكشف إمكانيات غير محدودة",
    subtitle: "خطط وأسعار مرنة تتناسب مع احتياجات عملك المختلفة.",
  },
  clients: {
    overline: "آراء العملاء",
    title: "ثقة تتزايد يومًا بعد يوم",
    subtitle:
      "تجارب حقيقية من منشآت تعمل يوميًا على المحاسب المحترف عبر مختلف القطاعات.",
  },
  faq: {
    overline: "الأسئلة الشائعة",
    title: "كل ما تحتاج معرفته — بإيجاز",
    subtitle: "إن لم تجد إجابتك هنا، تواصل معنا مباشرة وسنساعدك.",
  },
  contact: {
    overline: "تواصل معنا",
    title: "يسعدنا سماعك والإجابة على استفساراتك",
    subtitle: "املأ النموذج التالي أو تواصل مباشرة عبر واتساب أو الهاتف.",
  },
  footerCta: {
    title: "جاهز تبدأ؟ اطلب عرضًا تجريبيًا الآن",
    subtitle: "فريقنا يساعدك في التهيئة والبدء خلال أقصر وقت.",
    primary: "اطلع على الأسعار",
    secondary: "تواصل واتساب",
  },
};
